import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeSeatchText,
  changeSortOption,
} from "../../features/filters/filterSlice";

const FilterHeader = () => {
  const { search, sortOption, type } = useSelector((state) => state.filters);
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState(search);
  const [sortValue, setSortValue] = useState(sortOption);

  const handlesearchInput = (text) => {
    setSearchInput(text);
    dispatch(changeSeatchText(text));
  };

  const handleSortOption = (option) => {
    setSortValue(option);
    dispatch(changeSortOption(option));
  };

  return (
    <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
      <h1 className="lws-section-title">
        {type === "All" && "All"} Available
        {type === "Remote" && " Remote"}
        {type === "Internship" && " Internship"}
        {type === "Full Time" && " Full Time"} Jobs
      </h1>
      <div className="flex gap-4">
        <div className="search-field group flex-1">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Job"
            className="search-input"
            id="lws-searchJob"
            value={searchInput}
            onChange={(e) => handlesearchInput(e.target.value)}
          />
        </div>
        <select
          id="lws-sort"
          name="sort"
          autoComplete="sort"
          className="flex-1"
          value={sortValue}
          onChange={(e) => handleSortOption(e.target.value)}
        >
          <option value="">Default</option>
          <option value="Salary_Ascending_Order">Salary (Low to High)</option>
          <option value="Salary_Descending_Order">Salary (High to Low)</option>
        </select>
      </div>
    </div>
  );
};

export default FilterHeader;
